module.exports = __webpack_public_path__ + "img/content-img-2.00ef7d97.jpg";